<template>
  <ForgotPassForm :has-recaptcha="isRecaptchaEnabled" />
</template>

<script>
  import ForgotPassForm from '../../components/forms/auth/ForgotPass';

  export default {
    components: {
      ForgotPassForm,
    },
    data() {
      return {
        recaptcha: import.meta.env.VUE_APP_USE_RECAPTCHA,
        recaptchaKey: import.meta.env.VUE_APP_RECAPTCHA_KEY,
      };
    },
    computed: {
      isRecaptchaEnabled() {
        const { recaptcha, recaptchaKey } = this;

        return recaptcha === 'true' && recaptchaKey !== '';
      },
    },
    metaInfo() {
      return {
        title: this.$t('views_reset_second_title'),
      };
    },
  };
</script>
